<template>
  <div class="container text-start mt-3">
    <CustomAlert type="secondary" title="">
      <span class="h3 fw-bold">Admin</span>
    </CustomAlert>
    <AdminTable :entries="getAdminEntries" />
    <div class="row">
      <div class="col d-none">
        <AdminExport :entries="getAdminEntries" />
      </div>
      <div class="col" v-if="getOnid == 'breslinn'">
        <AdminReset />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import DatastoreAPI from "@/helpers/DatastoreAPI";

import AdminTable from "@/components/admin/AdminTable";
import AdminExport from "@/components/admin/AdminExport";
import AdminReset from "@/components/admin/AdminReset";
import CustomAlert from "@/components/ui/CustomAlert.vue";

export default {
  name: "AdminView",
  mixins: [DatastoreAPI],
  components: {
    AdminTable,
    AdminExport,
    AdminReset,
    CustomAlert
  },
  computed: {
    ...mapGetters(["getOnid"]),
    ...mapGetters("datastore", ["getAdminEntries"])
  }
};
</script>
